import styled from "styled-components";

export const DetailsGrid = styled.div`
  display: grid;
  gap: 15px;
`;

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
  
  &:last-child {
    border-bottom: none;
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 5px;
  }
`;

export const DetailLabel = styled.div`
  font-weight: 600;
  color: #495057;
  font-size: 14px;
`;

export const DetailValue = styled.div`
  color: #333;
  font-size: 14px;
  word-break: break-word;
  
  code {
    background-color: #f8f9fa;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 13px;
    color: #495057;
    font-family: 'Courier New', monospace;
  }
`;

export const StatusIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  
  background-color: ${props => props.$enabled ? '#e9ecef' : '#dee2e6'};
  color: ${props => props.$enabled ? '#2f2f2f' : '#1a1a1a'};
  border: 1px solid ${props => props.$enabled ? '#adb5bd' : '#8a8a8a'};
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  
  svg {
    animation: spin 1s linear infinite;
  }
  
  p {
    margin-top: 15px;
    color: #6c757d;
    font-size: 14px;
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

export const ErrorContainer = styled.div`
  padding: 20px;
  background-color: #dee2e6;
  border: 1px solid #8a8a8a;
  border-radius: 4px;
  color: #1a1a1a;
  text-align: center;
  
  p {
    margin: 0;
    font-size: 14px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
`;

export const CloseButton = styled.button`
  padding: 8px 20px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #5a6268;
  }
`;
